'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionAlert', ['$scope', '$stateParams', '$state', 'Alerts', '$rootScope',
        function ($scope, $stateParams, $state, Alerts, $rootScope) {
        $scope.resetInspection();
        $scope.inspection_alert = $stateParams.inspection_alert;
        $scope.inspectionAlertID = $stateParams.inspectionAlertID;
        $scope.saving = false;
        $scope.retiring = false;
        $scope.unretiring = false;
        $scope.loading = true;
        
        if ($stateParams.inspectionAlertID != null) {
            Alerts.getByID($stateParams.inspectionAlertID).then(function (alert) {
                $scope.inspection_alert = alert;
                $scope.loading = false;
            })
        }
        else {
            $scope.inspection_alert = {};
            $scope.loading = false;
        }

        $scope.save = function () {
            $scope.saving = true;

            Alerts.save($scope.inspection_alert, $scope.inspectionID).then(function (alert) {
                updateArray($scope.inspection.alerts, alert);
                updateArray($scope.masterInspection.alerts, alert);
                $state.go('internal.inspecting.inspection.alerts', { id: $scope.inspectionID });
                $scope.saving = false;
            });
        }

        $scope.retire = function () {
            $scope.retiring = true;
            $scope.inspection_alert.retired = true;
            $scope.inspection_alert.retired_on = new Date();
            $scope.inspection_alert.retired_by = $rootScope.userAccount.id;

            Alerts.save($scope.inspection_alert).then(function (alert) {
                $scope.inspection_alert = alert;
                updateArray($scope.inspection.alerts, alert);
                updateArray($scope.masterInspection.alerts, alert);
                $scope.retiring = false;
            });
        }

        $scope.unretire = function () {
            $scope.unretiring = true;
            $scope.inspection_alert.retired = false;
            $scope.inspection_alert.retired_on = null;

            Alerts.save($scope.inspection_alert).then(function (alert) {
                $scope.inspection_alert = alert;
                updateArray($scope.inspection.alerts, alert);
                updateArray($scope.masterInspection.alerts, alert);
                $scope.unretiring = false;
            });
        }
    }])
;